import CircularProgress from '@mui/material/CircularProgress';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

const styles = {
  loader: {
    opacity: 1,
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  blurred: {
    opacity: 0.7,
    filter: 'blur(1px)',
  },
};

export default class LoadBlur extends Component {
  static propTypes = {
    blurStyle: PropTypes.object,
    children: PropTypes.node,
    loading: PropTypes.bool,
    renderSpinner: PropTypes.func,
    showSpinner: PropTypes.bool,
    size: PropTypes.number,
    spinnerStyle: PropTypes.object,
    style: PropTypes.object,
    thickness: PropTypes.number,
  };
  static defaultProps = {
    showSpinner: true,
    size: 32,
    style: {},
    thickness: 8,
  };
  onClick = e => {
    e.stopPropagation();
    e.preventDefault();
  };
  renderSpinner = () => {
    const { size, spinnerStyle, thickness } = this.props;
    return (
      <CircularProgress
        // color='#88AD33'
        size={size}
        style={spinnerStyle}
        thickness={thickness}
      />
    );
  };
  render() {
    /* eslint-disable jsx-a11y/no-static-element-interactions */
    const { blurStyle, children, loading, renderSpinner, showSpinner, style } = this.props;
    return (
      <div style={{ position: 'relative', width: '100%', ...style }}>
        {showSpinner && loading && (
          <div
            // prevent clicks on underlying form when loading
            onClick={this.onClick}
            onKeyPress={this.onClick}
            style={styles.loader}
          >
            {renderSpinner ? renderSpinner() : this.renderSpinner()}
          </div>
        )}
        {children && (
          <div style={loading ? { ...styles.blurred, ...blurStyle } : null}>
            {children}
          </div>
        )}
      </div>
    );
  }
}
